import { ISolutionsComponent } from '@sapientpro/sapientpro-data-models';
import classnames from 'classnames';
import React from 'react';
import styles from './Solutions.module.scss';

type SolutionsProps = {
  data: ISolutionsComponent
};

const Solutions = ({ data }: SolutionsProps) => (
  <section className={classnames(styles.solutions, 'container')}>
    <h4 className={classnames('title4', styles.title)}>{data.title}</h4>
    <div className={styles.solutions__content}>
      {data.solutions.map(item => (
        <div
          key={item.id}
          className={styles.solution}
        >
          {item.text}
        </div>
      ))}
    </div>
  </section>
);

export default Solutions;
